<!--GeneratorFlag:[NoChange]-->
<template>
	<kaveh-table :task="getList" :entity="entity" :actions="actions" :filter-entity="filterEntity" />
</template>
<script>
	import { Tenant, TenantFilter } from '@/modules/hub/data/tenant/list'
	import { TenantService } from '@/modules/hub/services'
	export default {
		computed:
		{
			entity()
			{
				return Tenant;
			},
			
			filterEntity()
			{
				return TenantFilter;
			},

			service()
			{
				return new TenantService();
			},

			actions()
			{
				return [
					{
						routeName: 'hub.tenant.create',
						resourceKey: 'action.create',
						iconName: 'bi-plus-circle',
						activeMode: 'always',
					},
					{
						routeName: 'hub.tenant.createImport',
						resourceKey: 'action.import',
						iconName: 'bi-upload',
						activeMode: 'always',
					},

					{
						routeName: 'hub.tenant.update',
						resourceKey: 'action.update',
						iconName: 'bi-pen',
						activeMode: 'single',
						dataTransferMode: 'store',
					},

					{
						routeName: 'hub.tenant.delete',
						resourceKey: 'action.delete',
						iconName: 'bi-trash',
						activeMode: 'multiple',
						dataTransferMode: 'store',
					},
					{
						resourceKey: 'action.more',
						iconName: 'bi-arrow-down-short',
						activeMode: 'single',
						children: [
							{
								routeName: 'hub.tenant.list',
								resourceKey: 'hub.tenantList',
								iconName: 'bi-list-columns',
								activeMode: 'single',
								dataTransferMode: 'query',
								dataTransferKeys: ['tenantId'],
							},
							{
								routeName: 'hub.person.list',
								resourceKey: 'hub.personList',
								iconName: 'bi-list-columns',
								activeMode: 'single',
								dataTransferMode: 'query',
								dataTransferKeys: ['tenantId'],
							},
							{
								routeName: 'hub.personRole.list',
								resourceKey: 'hub.personRoleList',
								iconName: 'bi-list-columns',
								activeMode: 'single',
								dataTransferMode: 'query',
								dataTransferKeys: ['tenantId'],
							},

						]
					},

				]
			}
		},
		methods:
		{
			async getList(payload)
			{
				return await this.service.list(payload);
			}
		}
	}
</script>